import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

    constructor() { }

    public setItem(key: LocalStorageKeys, data: any): void {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            console.warn('LocalStorage setItem error:', e);
        }
    }

    public getItem(key: LocalStorageKeys): any {
        try {
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            console.warn('LocalStorage getItem error:', e);
            return null;
        }
    }

    public setStr(key: LocalStorageKeys, data: string): void {
        try {
            localStorage.setItem(key, data);
        } catch (e) {
            console.warn('LocalStorage setStr error:', e);
        }
    }

    public getStr(key: LocalStorageKeys): string {
        try {
            return localStorage.getItem(key) || '';
        } catch (e) {
            console.warn('LocalStorage getStr error:', e);
            return '';
        }
    }

    public removeItem(key: LocalStorageKeys): void {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.warn('LocalStorage removeItem error:', e);
        }
    }

    public clear(): void {
        try {
            localStorage.clear();
        } catch (e) {
            console.warn('LocalStorage clear error:', e);
        }
    }
}

export enum LocalStorageKeys {
    User = 'user',
    SessionId = 'sessionId',
    PrivacyConsent = 'privacy-consent-v1'
}